import { RouterModule, Routes } from '@angular/router';
/*
 * Services
 */
import { AuthenticatedRoutesGuard } from './../app/services/authenticated-routes-guard.service';
import { TeacherProductViewResolverService } from './../../modules/shared-postlogin/services/teacher-product-view-resolver.service';
import { AssignmentViewResolverService } from './services/assignment-view-resolver.service';
import { CreateAccessResolverService } from './services/create-access-resolver.service';
import { GradeActivitySelectionResolverService } from './services/grade-activity-selection-resolver.service';
import { SaveWarningGuard } from './../shared-postlogin/services/save-warning-guard.service';
import { CanDeactivateLPGuard } from './../shared-postlogin/services/can-deactivate-lp-guard.service';

/*
 * Components
 */
import { Teacher } from './components/main/teacher.component';
import { ProductView } from './../../modules/shared-postlogin/components/product-view/product-view.component';
import { ActivityLaunch } from './../../modules/shared-postlogin/components/activity-launch/activity-launch.component';
import { CreateAssignments } from './components/create-assignments/create-assignments.component';
import { Preview } from 'modules/learner/components/preview/preview.component';
import { SubmitLtiTest } from '../shared-postlogin/components/submit-lti-test/submit-lti-test.component';


const routes: Routes = [
    {
        path: 'teacher/preview', component : Preview
    },
    {
        path: 'teacher', component: Teacher, canActivate: [ AuthenticatedRoutesGuard ], children: [
            { path: ':spaceid/class/:classid/product/:productcode/grade-activity-selection', component: CreateAssignments, canDeactivate: [CanDeactivateLPGuard],
              data : { source : 'GRADE_ACTIVITY_SELECTION'}, resolve: { resolveData: GradeActivitySelectionResolverService }, children: [
                { path: 'item/:itemid', component: ActivityLaunch, canDeactivate: [SaveWarningGuard], data : { source : 'GRADE_ACTIVITY_SELECTION'} }
            ]},
            { path: ':spaceid/class/:classid/product/:productcode/create-access', component: CreateAssignments, canDeactivate: [CanDeactivateLPGuard],
              data : { source : 'CREATE_ACCESS_RULE'}, resolve: { resolveData: CreateAccessResolverService }, children: [
                { path: 'item/:itemid', component: ActivityLaunch, canDeactivate: [SaveWarningGuard], data : { source : 'CREATE_ACCESS_RULE'} }
            ]},
            { path: ':spaceid/class/:classid/product/:productcode/update-access/:ruleid', component: CreateAssignments, canDeactivate: [CanDeactivateLPGuard],
              data : { source : 'CREATE_ACCESS_RULE'}, resolve: { resolveData: CreateAccessResolverService }, children: [
                { path: 'item/:itemid', component: ActivityLaunch, canDeactivate: [SaveWarningGuard], data : { source : 'CREATE_ACCESS_RULE'} }
            ]},
            { path: ':spaceid/class/:classid/assignments/product/:productcode', component: CreateAssignments, canDeactivate: [CanDeactivateLPGuard],
              resolve: { resolveData: AssignmentViewResolverService }, children: [
                { path: 'item/:itemid', component: ActivityLaunch, canDeactivate: [SaveWarningGuard], data : { source : 'TEACHER_CREATE_ASSIGNMENT'} }
            ]},
            { path: ':spaceid/class/:classid/ltideeplinking/product/:productcode', component: CreateAssignments, canDeactivate: [CanDeactivateLPGuard],
              resolve: { resolveData: AssignmentViewResolverService }, children: [
                { path: 'item/:itemid', component: ActivityLaunch, canDeactivate: [SaveWarningGuard], data : { source : 'TEACHER_CREATE_ASSIGNMENT'} }
            ]},
            {
              path: ':spaceid/class/:classid/product/:productcode/edit-assignment/:assignmentid', component: CreateAssignments, canDeactivate: [CanDeactivateLPGuard],
              resolve: { resolveData: AssignmentViewResolverService },
              children: [
                { path: 'item/:itemid', component: ActivityLaunch, canDeactivate: [SaveWarningGuard], data: { source: 'TEACHER_EDIT_ASSIGNMENT' } }
              ],
              data: { source: 'TEACHER_EDIT_ASSIGNMENT' }
            },

            { path: ':spaceid/product/:productcode', component: ProductView, canDeactivate: [CanDeactivateLPGuard],
              resolve: { resolveData: TeacherProductViewResolverService }, children: [
                { path: 'item/:itemid', component: ActivityLaunch, canDeactivate: [SaveWarningGuard], data : { source : 'TEACHER_PREVIEW_LIBRARY'} }
            ]},
            { path: ':spaceid/class/:classid/product/:productcode', component: ProductView, canDeactivate: [CanDeactivateLPGuard],
              resolve: { resolveData: TeacherProductViewResolverService }, children: [
                { path: 'item/:itemid', component: ActivityLaunch, canDeactivate: [SaveWarningGuard], data : { source : 'TEACHER_PREVIEW_MATERIALS'} }
            ]},
            {
                path: ':spaceid/class/:classid/product/:productcode/unit/:unitcode', component: ProductView,
                canDeactivate: [CanDeactivateLPGuard],
                resolve: { resolveData: TeacherProductViewResolverService },
                children: [
                    { path: 'item/:itemid', component: ActivityLaunch, canDeactivate: [SaveWarningGuard], data: { source: 'TEACHER_PREVIEW_MATERIALS'} }
                ]
            },
            {
                path: ':spaceid/class/:classid/product/:productcode/unit/:unitcode/activity/:activityId', component: ProductView,
                canDeactivate: [CanDeactivateLPGuard],
                resolve: { resolveData: TeacherProductViewResolverService },
                children: [
                    { path: 'item/:itemid', component: ActivityLaunch, canDeactivate: [SaveWarningGuard], data: { source: 'TEACHER_PREVIEW_MATERIALS'} }
                ]
            },
            { path: ':spaceid/class/:classid/product/:productcode/assignment/:assignmentid', component: ProductView, canDeactivate: [CanDeactivateLPGuard],
              resolve: { resolveData: TeacherProductViewResolverService }, children: [
                { path: 'item/:itemid', component: ActivityLaunch, canDeactivate: [SaveWarningGuard], data : { source : 'TEACHER_VIEW_ASSIGNMENT'} }
            ]},
            { path: ':spaceid/class/:classid/product/:productcode/review-assignment/:assignmentid/user/:userid', data : { getLearnerUA : true}, component: ProductView,
              canDeactivate: [CanDeactivateLPGuard], resolve: { resolveData: TeacherProductViewResolverService }, children: [
                { path: 'item/:itemid', component: ActivityLaunch, canDeactivate: [SaveWarningGuard], data : { source : 'TEACHER_REVIEW_TEST'} }
            ]},
            { path: 'lti/submit/:ltiParamsKey', component: SubmitLtiTest },
            // Assuming all the routes with 'cefr-review' will have same page source.
            { path: ':spaceid/class/:classid/product/:productcode/cefr-review/:assignmentid/user/:userid', data : { getLearnerUA : true}, component: ProductView,
              canDeactivate: [CanDeactivateLPGuard], resolve: { resolveData: TeacherProductViewResolverService }, children: [
                { path: 'item/:itemid', component: ActivityLaunch, canDeactivate: [SaveWarningGuard], data : { source : 'TEACHER_CEFR_REVIEW_TEST'} }
            ]},
            { path: ':spaceid/class/:classid/product/:productcode/cefr-review/user/:userid', data : { getLearnerUA : true}, component: ProductView,
              canDeactivate: [CanDeactivateLPGuard], resolve: { resolveData: TeacherProductViewResolverService }, children: [
                { path: 'item/:itemid', component: ActivityLaunch, canDeactivate: [SaveWarningGuard], data : { source : 'TEACHER_CEFR_REVIEW_TEST'} }
            ]}
        ]
    }
];

export const ROUTES = RouterModule.forChild(routes);
